import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import useListReferencesById from 'flow-doctor-lib/hooks/useListReferencesById';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import EnvSpecificListNameLabel from 'flow-doctor-lib/components/timeline/labels/EnvSpecificListNameLabel';
import ImportListReferenceDisplayLabel from 'flow-doctor-lib/components/timeline/labels/ImportListReferenceDisplayLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const ListByReferenceDisplayLabel = ({
  logItem
}) => {
  const objectListMembership = logItem.type === 'LIST_MEMBERSHIP' ? logItem.data : logItem.data.objectListMembership;
  const {
    data: listReferences,
    loading: listReferencesLoading
  } = useListReferencesById({
    portalId: PortalIdParser.get(),
    listId: objectListMembership.listId
  });
  if (listReferencesLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  if ('INBOUNDDBIO_IMPORT' in listReferences) {
    return /*#__PURE__*/_jsx(ImportListReferenceDisplayLabel, {
      importId: listReferences.INBOUNDDBIO_IMPORT
    });
  }

  // TODO @jbartola: Add workflow-based lists

  // If no list references are found, default to the env-specific generic list label
  return /*#__PURE__*/_jsx(EnvSpecificListNameLabel, {
    logItem: logItem
  });
};
export default ListByReferenceDisplayLabel;